import React, { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * Persistent (but dismissible per-session) warning shown when the browser
 * doesn't expose Web Speech API. iOS Safari is the main target — voice
 * commands silently do nothing there, so we warn the user explicitly.
 */
export default function BrowserBanner() {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const hasSR = !!(window.SpeechRecognition || window.webkitSpeechRecognition);
    const dismissed = sessionStorage.getItem("vls.banner.dismissed") === "1";
    setShow(!hasSR && !dismissed);
  }, []);

  if (!show) return null;

  return (
    <div className="vls-browser-banner" role="alert" data-testid="ios-safari-banner">
      <AlertTriangle size={18} className="vls-browser-banner-icon" />
      <span className="vls-browser-banner-text">{t("browserWarnSafari")}</span>
      <button
        type="button"
        className="vls-browser-banner-close"
        aria-label={t("close")}
        data-testid="ios-safari-banner-close"
        onClick={() => {
          sessionStorage.setItem("vls.banner.dismissed", "1");
          setShow(false);
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
}
